import $ from 'jquery';

const $form = $('.js-course-select');

$form.on('change', 'select', () => $form.submit());
